

document.addEventListener('DOMContentLoaded', function () {

  class TertiaryNavigation {

    constructor() {

      this.tertiaryTrigger = document.querySelector('.tertiary-nav--title');

      this.tertiaryItems = document.querySelector('.tertiary-nav-container');

      this.revealTertiaryItems(this.tertiaryTrigger, this.tertiaryItems);

    }

    revealTertiaryItems(trigger, items) {

      if (trigger && items) {

        let tTrigger = trigger;

        tTrigger.addEventListener('click', () => {

          let mnuState = items.getAttribute('aria-hidden') === 'true' ? 'false' : 'true';

          items.setAttribute('aria-hidden', `${mnuState}`);

        });

      }

    }

  }

  new TertiaryNavigation();

});